import { Plugin } from "chart.js";
import { AnyObject } from "chart.js/dist/types/basic";

export const yAxisUnitsPlugin = (
    label1?: string,
    label2?: string
): Plugin<"scatter", AnyObject> => ({
    id: "unitsLabel",
    afterDraw: (chart) => {
        if (!label1) return;

        const ctx = chart.ctx;
        const y1Axis = chart.scales.y1;
        const y2Axis = chart.scales.y2;
        if (!y1Axis) {
            console.log("Y-axis not found");
            return;
        }

        // Get the position at the center-top of the y-axis
        const x1 = y1Axis.left + y1Axis.width;
        const y = y1Axis.top - 0; // 10px above the axis

        const tickFont = chart.options.scales?.y1?.ticks?.font;
        const fontSize =
            tickFont && "size" in tickFont ? (tickFont.size as number) : 12; // Default to 12 if not defined
        // Style the text
        ctx.save();
        ctx.font = `bold ${fontSize + 1}px Arial`;
        // ctx.font = "bold 12px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";

        // Draw the units label
        ctx.fillText(label1, x1, y); // Replace 'Units' with your actual unit

        if (label2 && y2Axis) {
            const x2 = y2Axis.right - y2Axis.width;
            ctx.fillText(label2, x2, y);
        }

        ctx.restore();
    },
});
